import { render } from "./Stories.vue?vue&type=template&id=63debdf3"
import script from "./Stories.vue?vue&type=script&lang=js"
export * from "./Stories.vue?vue&type=script&lang=js"

import exportComponent from "/home/wordpressswitchlitseptemberdevnl/wordpress.switchlit.septemberdev.nl/web/app/themes/switchlit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__